export interface SocialDepartment {
  id?: string
  name?: string | null
  display_name?: string | null
}

export interface SocialAuthor {
  id: string
  name?: string | null
  avatar_url?: string | null
  department?: SocialDepartment | SocialDepartment[] | null
}

export interface SocialReaction {
  id: string
  post_id: string
  user_id: string
  emoji: string
  created_at: string
  user?: SocialAuthor
}

export interface SocialComment {
  id: string
  post_id: string
  author_id: string
  content: string
  created_at: string
  updated_at: string
  edited_at: string | null
  author?: SocialAuthor
}

export interface SocialPostImage {
  id: string
  post_id: string
  file_path: string
  file_name: string
  file_size?: number | null
  mime_type?: string | null
  sort_order: number
  uploaded_by?: string | null
  created_at?: string
  /** URL assinada, preenchida no service ao listar/criar */
  url?: string
}

export interface SocialPost {
  id: string
  author_id: string
  content: string
  created_at: string
  updated_at: string
  edited_at: string | null
  deleted_at?: string | null
  deleted_by?: string | null
  author?: SocialAuthor
  reactions?: SocialReaction[]
  comments?: SocialComment[]
  comment_count?: number
  images?: SocialPostImage[]
}

export interface SocialEdit {
  id: string
  post_id: string | null
  comment_id: string | null
  previous_content: string
  edited_by: string
  edited_at: string
  editor?: SocialAuthor
}

export const SOCIAL_REACTION_EMOJIS = ['👍', '💚', '😂', '😮', '🎉', '👏'] as const

export type SocialReactionEmoji = (typeof SOCIAL_REACTION_EMOJIS)[number]

export const SOCIAL_REACTION_ASSETS: Record<
  SocialReactionEmoji,
  { src: string; label: string }
> = {
  '👍': { src: '/Joia.png', label: 'Joinha' },
  '💚': { src: '/Coracao.png', label: 'Coração' },
  '😂': { src: '/Risada.png', label: 'Risada' },
  '😮': { src: '/supreso.png', label: 'Surpreso' },
  '🎉': { src: '/Festa.png', label: 'Festa' },
  '👏': { src: '/Palmas.png', label: 'Palmas' },
}

export const SOCIAL_POST_MAX_LENGTH = 2000
export const SOCIAL_COMMENT_MAX_LENGTH = 1000
export const SOCIAL_POST_MAX_IMAGES = 4
export const SOCIAL_POST_IMAGE_MAX_BYTES = 5 * 1024 * 1024 // 5 MB
export const SOCIAL_POST_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
] as const
